var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootcampjscalendario2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mkv0b4jcua)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#sg25ytt9ab)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.218 4.337c.528-.383 1.164-.582 2.032-.685v.723a1.25 1.25 0 1 0 2.5 0v-.831c.387-.002.802-.002 1.25-.002.448 0 .863 0 1.25.002v.831a1.25 1.25 0 1 0 2.5 0v-.723c.868.103 1.504.302 2.032.685.354.257.665.569.922.922.47.648.663 1.458.742 2.658H2.554c.08-1.2.271-2.01.742-2.658.257-.354.568-.665.922-.922z",
    fill: "url(#pr915ueylc)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.509 9.166c-.009.556-.009 1.176-.009 1.876 0 3.124 0 4.687.796 5.782.257.354.568.665.922.922 1.095.796 2.657.796 5.782.796.7 0 1.32 0 1.875-.01v-.058c0-.71 0-1.142.059-1.515a4.792 4.792 0 0 1 3.983-3.983c.373-.06.806-.06 1.516-.06h.058c.009-.554.009-1.175.009-1.874 0-.7 0-1.32-.009-1.876H2.51z",
    fill: "url(#l701a8nxhd)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.782 17.746c-.647.47-1.457.663-2.657.741 0-.758.003-1.076.044-1.333a3.542 3.542 0 0 1 2.944-2.944c.257-.04.574-.043 1.333-.043-.08 1.2-.272 2.01-.742 2.657a4.166 4.166 0 0 1-.922.922z",
    fill: "url(#ojfc8o4ype)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.125 1.875a.625.625 0 1 0-1.25 0v2.5a.625.625 0 1 0 1.25 0v-2.5z",
    fill: "url(#j9pyp1rydf)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 1.875a.625.625 0 1 0-1.25 0v2.5a.625.625 0 1 0 1.25 0v-2.5z",
    fill: "url(#gw28nft82g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.375 3.134-.184.022c-.912.108-1.643.324-2.267.777A4.667 4.667 0 0 0 2.89 4.965c-.555.764-.755 1.692-.835 2.919l-.035.533H17.979l-.034-.533c-.081-1.228-.281-2.155-.836-2.919a4.665 4.665 0 0 0-1.033-1.032c-.624-.453-1.355-.67-2.267-.777l-.184-.022V1.875a1.125 1.125 0 0 0-2.25 0v1.17l-.122-.001c-.388-.002-.805-.002-1.252-.002h-.002c-.447 0-.864 0-1.252.002h-.122V1.876a1.125 1.125 0 0 0-2.25 0v1.259zm-3.86 5.533-.498-.006-.008.497C2 9.718 2 10.342 2 11.038v.034c0 1.537 0 2.73.102 3.676.104.96.32 1.723.79 2.37.287.396.635.745 1.032 1.032.647.47 1.41.685 2.37.79.945.102 2.139.102 3.675.102h.034c.697 0 1.32 0 1.88-.01l.492-.007V18.474c0-.726.001-1.112.053-1.437a4.292 4.292 0 0 1 3.567-3.567c.325-.052.712-.053 1.438-.053h.55l.008-.492c.009-.56.009-1.184.009-1.88v-.006c0-.697 0-1.321-.009-1.88l-.008-.499-.498.007H2.515zm10.11 9.82v.534l.533-.035c1.227-.08 2.154-.28 2.918-.836a4.664 4.664 0 0 0 1.033-1.032c.555-.764.755-1.691.835-2.919l.035-.532h-.534c-.74 0-1.105.001-1.41.05a4.042 4.042 0 0 0-3.36 3.36c-.049.305-.05.67-.05 1.41z",
    stroke: "url(#0l88f73kkh)",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#so2w5xpjni)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25a.625.625 0 1 0 0 1.25h5a.625.625 0 1 0 0-1.25h-5z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pr915ueylc",
    x1: 10,
    y1: 1.25,
    x2: 10,
    y2: 18.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l701a8nxhd",
    x1: 10,
    y1: 1.25,
    x2: 10,
    y2: 18.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ojfc8o4ype",
    x1: 10,
    y1: 1.25,
    x2: 10,
    y2: 18.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j9pyp1rydf",
    x1: 10,
    y1: 1.25,
    x2: 10,
    y2: 18.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gw28nft82g",
    x1: 10,
    y1: 1.25,
    x2: 10,
    y2: 18.542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBBF30",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBF30"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0l88f73kkh",
    x1: 2.5,
    y1: 1.25,
    x2: 19.625,
    y2: 16.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sg25ytt9ab",
    x: -22.514,
    y: -23.75,
    width: 65.027,
    height: 67.305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_402_2552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_402_2552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "so2w5xpjni",
    x: 3.875,
    y: 8.25,
    width: 22.25,
    height: 17.25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.176471 0 0 0 0 0.556863 0 0 0 0 0.678431 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_402_2552"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_402_2552",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "mkv0b4jcua"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootcampjscalendario2);
export default __webpack_public_path__ + "static/media/Bootcamp js calendario 2.c6b935494fa788d64a4b03dc17a155d5.svg";
export { ForwardRef as ReactComponent };